import { isObject } from '../../../helpers/check';

const checkboxObjectToArrayWithTrueValues = values =>
  (values && isObject(values) ? Object.keys(values).filter(key => !!values[key]) : []);

export default checkboxObjectToArrayWithTrueValues;
